import React from "react";
import type { LoyaltyState } from "@/types";
import { useI18n } from "@/i18n";

const PER_REWARD = 10;

export function LoyaltyBanner({ loyalty }: { loyalty: LoyaltyState }) {
  const { t } = useI18n();
  const done = loyalty.hasRewardAvailable || loyalty.rewardPending ? PER_REWARD : PER_REWARD - loyalty.ordersUntilReward;
  const progressPct = Math.round((done / PER_REWARD) * 100);

  return (
    <div className="loyalty">
      <div className="loyalty__mark" aria-hidden="true">
        {loyalty.hasRewardAvailable || loyalty.rewardPending ? (
          <span className="diamond" style={{ width: 9, height: 9, background: "var(--color-accent)" }} />
        ) : (
          <span style={{ fontSize: 12, fontWeight: 600 }}>
            {done}/{PER_REWARD}
          </span>
        )}
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: "var(--font-display)", fontSize: 15.5, lineHeight: 1.35, marginBottom: 8 }}>
          {loyalty.hasRewardAvailable
            ? t("home.loyaltyReady")
            : loyalty.rewardPending
              ? t("home.loyaltyPending")
              : t("home.loyaltyProgress", { count: loyalty.ordersUntilReward })}
        </div>
        {!loyalty.hasRewardAvailable && !loyalty.rewardPending && (
          <div style={{ height: 3, borderRadius: 2, background: "var(--color-line)", overflow: "hidden" }}>
            <div style={{ width: `${progressPct}%`, height: "100%", background: "var(--color-primary)" }} />
          </div>
        )}
      </div>
    </div>
  );
}
